/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type OrganizerAutopilotPausedFreemiumCallout_event = {
    readonly eventParentRelayId: string;
    readonly organizer: {
        readonly urnValue: string;
    } | null;
    readonly " $refType": "OrganizerAutopilotPausedFreemiumCallout_event";
};
export type OrganizerAutopilotPausedFreemiumCallout_event$data = OrganizerAutopilotPausedFreemiumCallout_event;
export type OrganizerAutopilotPausedFreemiumCallout_event$key = {
    readonly " $data"?: OrganizerAutopilotPausedFreemiumCallout_event$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"OrganizerAutopilotPausedFreemiumCallout_event">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrganizerAutopilotPausedFreemiumCallout_event",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "eventParentRelayId",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "Attendee",
            "kind": "LinkedField",
            "name": "organizer",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "urnValue",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Event",
    "abstractKey": null
} as any;
(node as any).hash = 'c962fa05d6461f7693181aac8cd89f54';
export default node;
